import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class PredefinedMesgStore {
  loading = false;
  total = 0;
  messageList = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      messageList: observable,

      loadData: action,
      deleteRecord: action,

      addData: action,
      getMessageData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, page }) {
    this.loading = true;
    var postData = {
      offset: offset,
      limit: limit,
      page: page,
    };
    if (config.pythonReport == 1) {
      console.log("oooooooooop");
      var response = await postApi
        .getClient()
        .get(
          config.NodeUrl + "/predefinedMessageList/getpredefinedMessageList",
          { params: postData },
        );
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=predefinedMessage&a=predefinedMessageList",
          "postData=" + base64Input,
        );
    }

    this.messageList = response?.data?.data?.MessageData;
    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async addData(messageData) {
    var postData = messageData;
    if (config.pythonReport == 1) {
      console.log("oooooooooop");
      var response = await postApi
        .getClient()
        .post(
          config.NodeUrl +
            "/predefinedMessageList/createOrUpdatePredefinedMessage",
          postData,
        );
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=predefinedMessage&a=update",
          "postData=" + base64Input,
        );
    }

    return response.data;
  }

  async getMessageData(id) {
    var postData = {
      id: id,
      limit: 1,
      offset: 0,
    };
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .get(
          config.NodeUrl + "/predefinedMessageList/getpredefinedMessageList",
          { params: postData },
        );
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=predefinedMessage&a=predefinedMessageList",
          "postData=" + base64Input,
        );
    }

    return response?.data?.data?.MessageData[0];
  }

  async deleteRecord({ id }) {
    const postData = { Id: id };
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient()
        .delete(
          config.NodeUrl +
            `/predefinedMessageList/deletePredefinedMessage/${postData.Id}`,
        );
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=predefinedMessage&a=delete",
          "postData=" + base64Input,
        );
    }

    return response;
  }
}

export default PredefinedMesgStore;
